import React, { Component } from 'react';
import { connect } from 'react-redux';
import Title from '../../../Title';
import Button from '../../../Button';
import { getPlanByServerValue } from '../../../../constants/plans';
import { billRegistration } from '../../../../reducers/billRegistration';
import { getMemberShipPlan, isDealInfoLoaded, getMemberShipPlanPeriod } from '../../../../reducers/DealInfo';
import Spinner from '../../../Spinner';
import env from '../../../../config/env';

const POS = window.POS;

const formStyle = {
  base: {
    color: '#363c3e',
    borderStyle: 'solid',
    borderWidth: '0 0 1px',
    lineHeight: 1,
    outline: 0,
    padding: 16,
    textAlign: 'center',
    width: '100%',
    marginBottom: '16px',
    cvv: {
      width: 'calc(50% - 10px)'
    },
    expirationDate: {
      marginLeft: '20px',
      width: 'calc(50% - 10px)'
    },
    secureFields: {
      width: '100%'
    }
  }
};

class PaymentForm extends Component {
  constructor() {
    super();
    this.state = {
      errors: {}
    };
    this.cardHolderIdRef = React.createRef();
    this.cardHolderNameRef = React.createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const i18n = this.props.lang.i18n;

    POS.setStyle(formStyle);
    POS.setDirectionRtl();
    POS.disableCardImage();
    POS.disableLuhnValidation();
    POS.setCardNumberPlaceholder(i18n('onboarding.creditCardPaymentForm.creditNumberFieldPlaceholder'));
    POS.setExpirationDatePlaceholder(i18n('onboarding.creditCardPaymentForm.creditNumberExpiry'));
    POS.setPublicKey(env.isProduction() ? env.PAYMENT_OS_CONFIG.PROD_PUBLIC_KEY : env.PAYMENT_OS_CONFIG.DEV_PUBLIC_KEY);
    POS.setEnvironment(env.isProduction() ? 'live' : 'test');
    POS.initSecureFields('card-secure-fields');
  }

  handleSubmit() {
    const additionalData = {
      identity_document: {
        number: this.cardHolderIdRef.current.value
      },
      holder_name: this.cardHolderNameRef.current.value
    };

    this.setState({ errors: { cardName: !additionalData.holder_name, identity_document: !additionalData.identity_document.number } });

    if (!additionalData.identity_document.number || !additionalData.holder_name) return;

    this.paymentErrorState(false);
    POS.createToken(additionalData, result => {
      let resultData;
      try {
        if (!result) {
          this.paymentErrorState(true);
          return;
        }
        resultData = JSON.parse(result);
        if (resultData.category === 'client_validation_error' || resultData.category === 'api_request_error') {
          this.paymentErrorState(true);
        }
        // advance to payments
        this.props.billRegistration(resultData.token, resultData.encrypted_cvv);
      } catch (error) {
        this.paymentErrorState(true);
      }
    });
  }
  paymentErrorState(value) {
    this.setState({ errors: { paymentError: value } });
  }
  componentDidUpdate() {
    if (this.props.status === 'COMPLETED') this.props.next();
  }

  render() {
    const i18n = this.props.lang.i18n;
    const plan = getPlanByServerValue(this.props.membershipPlan);
    const period = this.props.membershipPlanPeriod || 'Monthly';

    return (
      <div className="payment-form text-center">
        <Title
          text={i18n(
            `${
              this.state.errors.paymentError || this.props.status === 'ERROR'
                ? 'onboarding.creditCardPaymentForm.titleError'
                : 'onboarding.creditCardPaymentForm.title'
            }`
          )}
          className={`${this.state.errors.paymentError ? 'color-red' : ''} form__title`}
        />
        <p className="mb-5">
          {(plan.discountedMonth || plan.discountedMonth === 0) && (
            <span className="bold">
              {i18n('onboarding.creditCardPaymentForm.firstMonth')}
              {plan.discountedMonth} {plan.discountedMonth > 0 ? 'ש״ח' : ''} {i18n('onboarding.creditCardPaymentForm.afterFirstMonth')}{' '}
            </span>
          )}
          {plan.price[period]} ש״ח {i18n('onboarding.creditCardPaymentForm.costSummaryPeriod')}
        </p>
        <div className="row justify-content-center">
          <div className="col-9 col-sm-5">
            <form id="payment-form" className={`${this.state.errors.paymentError ? 'payment-error' : ''} px-2`} onSubmit={this.handleSubmit}>
              <div>
                <input
                  ref={this.cardHolderNameRef}
                  className={`form__input ${this.state.errors.cardName ? 'form__input--error' : 'mw-100 mb-3'}`}
                  type="text"
                  name="name"
                  onChange={this.captureInputs}
                  onClick={this.selectAllText}
                  placeholder={i18n('onboarding.creditCardPaymentForm.cardHolderName')}
                />
                {this.state.errors.cardName ? (
                  <div className="form__error-small">{i18n('onboarding.creditCardPaymentForm.cardNameMissing')}</div>
                ) : (
                  undefined
                )}
              </div>
              <div>
                <input
                  ref={this.cardHolderIdRef}
                  className={`form__input ${this.state.errors.identity_document ? 'form__input--error' : 'mw-100 mb-3'}`}
                  type="text"
                  name="name"
                  onChange={this.captureInputs}
                  onClick={this.selectAllText}
                  placeholder={i18n('onboarding.userDetails.nationalId')}
                />
                {this.state.errors.identity_document ? (
                  <div className="form__error-small">{i18n('onboarding.creditCardPaymentForm.idNumberMissing')}</div>
                ) : (
                  undefined
                )}
              </div>
              <div id="card-secure-fields" className="mb-5" />
            </form>
            {this.state.errors.paymentError || this.props.status === 'ERROR' ? (
              <p className="color-red bold">{i18n('onboarding.creditCardPaymentForm.missingDetails')}</p>
            ) : (
              undefined
            )}
            <Button text={i18n('onboarding.creditCardPaymentForm.buttonText')} onClick={this.handleSubmit} />
          </div>
        </div>
        {this.props.status === 'IN_PROGRESS' ? <Spinner /> : undefined}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userDetails: state.setUserDetails,
  status: state.billRegistration.status,
  lang: state.lang,
  membershipPlan: getMemberShipPlan(state),
  membershipPlanPeriod: getMemberShipPlanPeriod(state),
  isDealInfoLoaded: isDealInfoLoaded(state)
});

const mapDispatchToProps = dispatch => ({
  billRegistration: (token, cvv) => dispatch(billRegistration(token, cvv))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentForm);



// WEBPACK FOOTER //
// ./src/components/Views/OnboardingVirtualMembers/Steps/PaymentForm.js